import * as yup from 'yup';

export const comprobanteSchema = yup.object().shape({
  tipo: yup.string()
    .oneOf(['Boleta', 'Factura', 'Sin Doc'])
    .required('Tipo de comprobante obligatorio'),

  nombreEmpresa: yup.string().when('tipo', {
    is: (tipo) => tipo !== 'Sin Doc',
    then: (schema) => schema.required('Nombre de la empresa obligatorio'),
    otherwise: (schema) => schema.notRequired(),
  }),
    
  rutEmpresa: yup.string().when('tipo', {
    is: (tipo) => tipo !== 'Sin Doc',
    then: (schema) => schema
      .matches(/^[0-9]+[-]{1}[0-9kK]{1}$/, 'RUT inválido (ej: 12345678-9)')
      .required('RUT obligatorio'),
    otherwise: (schema) => schema.notRequired(),
  }),

  codigo: yup.number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .typeError('Debe ser un número')
    .positive('Debe ser un número positivo')
    .when('tipo', {
      is: (tipo) => tipo !== 'Sin Doc',
      then: (schema) => schema.required('Código obligatorio'),
      otherwise: (schema) => schema.notRequired(),
  }),

  precioNeto: yup.number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .typeError('Debe ser un número')
    .positive('Debe ser un número positivo')
    .when('tipo', {
      is: (tipo) => tipo !== 'Sin Doc',
      then: (schema) => schema.required('Precio neto obligatorio'),
      otherwise: (schema) => schema.notRequired(),
  }),

  fecha: yup.date()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .typeError('Fecha inválida')
    .when('tipo', {
      is: (tipo) => tipo !== 'Sin Doc',
      then: (schema) => schema.required('Fecha de emisión obligatoria'),
      otherwise: (schema) => schema.notRequired(),
  }),
});

export const productoSchema = yup.object().shape({
  nombre: yup.string()
    .required('Nombre del producto obligatorio'),
  descripcion: yup.string()
    .max(50, 'No debe sobrepasar los 50 caracteres'),
  usarCodigoFijo: yup.boolean().default(false),
  codigoBarra: yup.string()
    .transform(v => (v ? String(v).trim().toUpperCase() : v))
    .when('usarCodigoFijo', {
      is: true,
      // Si usa código fijo, NO valida (ni requiere)
      then: (s) => s.notRequired(),
      // Si NO usa código fijo, valida normalmente
      otherwise: (s) =>
        s.required('Código de barra obligatorio')
          .test(
            'valid-barcode',
            'Debe ser alfanumérico (≥ 5) y puede incluir "-" o "NO-BARCODE"',
            v => !!v && (v === 'NO-BARCODE' || /^(?=.{5,}$)[A-Z0-9-]+$/.test(v))
          ),
    }),
  codigoCode: yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Solo caracteres alfanuméricos'),
  codigoOem: yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Solo caracteres alfanuméricos'),
  marca: yup.string()
    .required('Marca obligatoria'),
  medida: yup.number()
    .typeError('Debe ser un número')
    .positive('Debe ser mayor a 0')
    .required('La medida es obligatoria'),
  unidad: yup.string()
    .oneOf(['Kg', 'g', 'L', 'ml', 'cc', 'mt', 'cm', 'un'], 'Unidad no válida')
    .required('La unidad es obligatoria'),
  cantidad: yup.number()
    .typeError('Debe ser un número')
    .positive('Debe ser mayor a 0')
    .required('La cantidad es obligatoria'),
  precio: yup.number()
    .typeError('Debe ser un número')
    .positive('Debe ser un valor mayor a 0')
    .required('El precio es obligatorio'),
  cuentaContable: yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Solo caracteres alfanuméricos')
    .max(20, 'No debe sobrepasar los 20 caracteres')
    .required('La cuenta contable es obligatoria'),
  bodega: yup.string()
    .oneOf(['Bodega 1', 'Bodega 2', 'Bodega 3'], 'Bodega no válida')
    .required('La bodega es obligatoria'),
});